import { Stack, Tooltip, Typography, useTheme } from "@mui/material";

export function FacilitiesCell({
  facilities,
}: {
  facilities: {
    name: string;
    id: string;
  }[];
}) {
  const theme = useTheme();
  return (
    <Stack
      spacing={0}
      style={{
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        height: "100%",
        width: "100%",
        alignItems: "start",
        overflow: "hidden",
      }}
    >
      {facilities.map((facility) => (
        <Typography
          key={facility.id}
          variant="body2"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "inherit",
            whiteSpace: "nowrap",
          }}
        >
          <Tooltip title={facility.name}>
            <span>{facility.name}</span>
          </Tooltip>
        </Typography>
      ))}
    </Stack>
  );
}
